import React, { useState } from "react";
//#region types
import { TranslationKeys } from "translations";
import { CreateCustomerProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import { PageLayouts, SimpleEntityTitle, ViewPanel } from "components/common";
import CustomerCreateFormContainer from "./forms/createFormContainer";
import CustomerRating from "./customerRating";
import { useCustomerService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";

const CreateCustomer: React.FC<CreateCustomerProps> = (props) => {
  const customerService = useCustomerService();
  const { customerName, onFormSubmitSuccess } = props;

  const [customerRating, setCustomerRating] = useState<number | null | undefined>(undefined);
  const [selectedCustomerName, setSelectedCustomerName] = useState<string>();

  const onOrganizationNumberChange = (orgNr?: string) => {
    if (orgNr)
      customerService.getCustomerRating(undefined, orgNr).then((rating) => {
        setCustomerRating(rating);
      });
    else setCustomerRating(null);
  };

  return (
    <PageLayouts.EntityCreationLayout
      layoutKey={"customerCreationLayout"}
      upperLeftComponent={
        <SimpleEntityTitle
          title={
            UtilsHelper.isEmpty(selectedCustomerName)
              ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.NewCustomer)
              : selectedCustomerName!
          }
        />
      }
      upperRightComponent={<></>}
      lowerLeftComponent={<CustomerRating value={customerRating} />}
      footer={<></>}
    >
      <ViewPanel className={cssExports.wizardOuter}>
        <CustomerCreateFormContainer
          customerName={customerName}
          organizationNumberChangeHandler={onOrganizationNumberChange}
          selectedCustomerChangeHandler={setSelectedCustomerName}
          onFormSubmitSuccess={onFormSubmitSuccess}
        />
      </ViewPanel>
    </PageLayouts.EntityCreationLayout>
  );
};

export default CreateCustomer;
